import { useMemo as l } from "react";
import { createPortal as u } from "react-dom";
import { useIsomorphicLayoutEffect as m } from "../../utils/hooks/useIsomorphicLayoutEffect.js";
const s = ({ children: d, containerRef: n, type: t = "div", className: i }) => {
  const e = typeof window > "u" || typeof document > "u", o = l(
    () => e ? null : document.createElement(t),
    [e, t]
  );
  return o && (o.className = i ? `louis-portal ${i}` : "louis-portal"), m(() => {
    if (e || !o)
      return;
    const r = n?.current || document.body;
    return r.appendChild(o), () => {
      r.contains(o) && r.removeChild(o);
    };
  }, [n, t, e]), !e && o ? u(d, o) : null;
};
s.displayName = "Portal";
export {
  s as Portal
};
//# sourceMappingURL=Portal.js.map
